import styled from 'styled-components';
import { StyledFormControlLabel } from '../containers/formControlLabel';
import { FormCheckbox } from '../../../../components';
import { Field } from 'react-final-form';

const Wrapper = styled.div`
  display: flex;
  margin-top: 12px;
`;

export const ConfirmSms = () => {
  return (
    <Wrapper>
      <StyledFormControlLabel
        control={<Field name={'confirm_sms'} component={FormCheckbox} color="primary" />}
        label={`By checking the box, I agree to receive text messages from Autoaxess regarding announcements and company updates. Reply to any message with STOP at any time to stop receiving messages. The frequency of messages varies. Message and data rates may apply.`}
      />
    </Wrapper>
  );
};
